import React, { useState } from 'react';
import axios from 'axios';

export default function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (loading) return;

    try {
      setLoading(true);
      setError('');
      const res = await axios.post('/api/login', { username, password });
      localStorage.setItem('token', res.data.token);
      axios.defaults.headers.common.Authorization = `Bearer ${res.data.token}`;
      onLogin();
    } catch (err) {
      const status = err?.response?.status;
      const data = err?.response?.data || {};

      if (status === 401 && Number.isInteger(data.attemptsRemaining)) {
        setError(`Invalid username or password. Attempts remaining: ${data.attemptsRemaining}.`);
      } else if (status === 429) {
        const retryAfter = Number(err?.response?.headers?.['retry-after']);
        const minutes = retryAfter ? Math.max(1, Math.ceil(retryAfter / 60)) : 15;
        setError(`Too many attempts from this IP. Try again in ${minutes} min.`);
      } else {
        setError(data.error || 'Login failed. Try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      submit();
    }
  };

  return (
    <div className="auth-card">
      <div className="auth-card-inner">
        <h2 className="auth-title">Login</h2>

        {error ? <div className="alert alert-danger auth-error">{error}</div> : null}

        <div className="auth-field">
          <label className="app-editor-label compact-label">Username</label>
          <input
            className="form-control compact-input"
            placeholder="Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyDown={onKeyDown}
          />
        </div>

        <div className="auth-field">
          <label className="app-editor-label compact-label">Password</label>
          <input
            type="password"
            className="form-control compact-input"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyDown={onKeyDown}
          />
        </div>

        <button className="btn btn-dark w-100 dashboard-btn auth-submit" onClick={submit} disabled={loading}>
          {loading ? 'Signing in...' : 'Login'}
        </button>
      </div>
    </div>
  );
}
